import React from 'react';
import '../Styles/Contact.css';

function Contact() {
  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="section-header text-center mb-5">
          <h2>Contact <span className="highlight">Us</span></h2>
          <p>Have a project in mind or want to collaborate? We'd love to hear from you.</p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <form className="contact-form">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input type="text" className="form-control" placeholder="Your Name" required />
                </div>
                <div className="col-md-6 mb-3">
                  <input type="email" className="form-control" placeholder="Your Email" required />
                </div>
                <div className="col-12 mb-3">
                  <input type="text" className="form-control" placeholder="Subject" required />
                </div>
                <div className="col-12 mb-4">
                  <textarea className="form-control" rows="5" placeholder="Your Message" required></textarea>
                </div>
                <div className="col-12 text-center">
                  <button type="submit" className="btn btn-primary px-4 py-2">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
